import { extendClass } from './extend-class'
import { SeDateTimeFormatter } from './date-time-formatter'
import {
  SeDateTimeString,
  SeDateTimeOptions,
  SeDateTimeFormat,
} from './date-time-types'

const SE_DATE_TIME_STRING: RegExp = /\d:\d\d/ // if we see 0:0 we assume it's a time

export abstract class SeDateFormatter {

  public initDate(value: SeDateTimeString, options: SeDateTimeOptions): void {
    this.hasTime = (!('tbdTime' in options)) && SE_DATE_TIME_STRING.test(value as SeDateTimeString)
  }

  public get shortDate(): string {
    return this.format(SeDateTimeFormat.ShortDate, () => this.differentDays)
  }

  public get date(): string {
    return this.format(SeDateTimeFormat.Date, () => this.differentDays)
  }

  public get fullDate(): string {
    return this.format(SeDateTimeFormat.FullDate, () => this.differentDays)
  }

  public get dayOfWeek(): string {
    return this.format(SeDateTimeFormat.DayOfWeek, () => this.differentDays)
  }

  public get month(): string {
    return this.format(SeDateTimeFormat.Month, () => this.differentMonths)
  }

  public get dayOfMonth(): string {
    return this.format(SeDateTimeFormat.DayOfMonth, () => this.differentDays)
  }

  public get year(): string {
    return this.format(SeDateTimeFormat.Year, () => this.differentYears)
  }

}

export interface SeDateFormatter extends SeDateTimeFormatter {}
extendClass(SeDateFormatter, SeDateTimeFormatter)
